"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.apiHeaders = exports.UtilsClass = exports.utils = void 0;
const icc_api_1 = require("../icc-api");
const icc_user_x_api_1 = require("./icc-user-x-api");
const icc_crypto_x_api_1 = require("./icc-crypto-x-api");
const icc_contact_x_api_1 = require("./icc-contact-x-api");
const icc_invoice_x_api_1 = require("./icc-invoice-x-api");
const icc_document_x_api_1 = require("./icc-document-x-api");
const icc_hcparty_x_api_1 = require("./icc-hcparty-x-api");
const icc_form_x_api_1 = require("./icc-form-x-api");
const icc_helement_x_api_1 = require("./icc-helement-x-api");
const icc_classification_x_api_1 = require("./icc-classification-x-api");
const icc_calendar_item_x_api_1 = require("./icc-calendar-item-x-api");
const icc_patient_x_api_1 = require("./icc-patient-x-api");
const icc_message_x_api_1 = require("./icc-message-x-api");
const icc_receipt_x_api_1 = require("./icc-receipt-x-api");
const icc_accesslog_x_api_1 = require("./icc-accesslog-x-api");
const icc_time_table_x_api_1 = require("./icc-time-table-x-api");
__exportStar(require("./icc-accesslog-x-api"), exports);
__exportStar(require("./icc-bekmehr-x-api"), exports);
__exportStar(require("./icc-calendar-item-x-api"), exports);
__exportStar(require("./icc-classification-x-api"), exports);
__exportStar(require("./icc-code-x-api"), exports);
__exportStar(require("./icc-contact-x-api"), exports);
__exportStar(require("./icc-crypto-x-api"), exports);
__exportStar(require("./icc-doctemplate-x-api"), exports);
__exportStar(require("./icc-document-x-api"), exports);
__exportStar(require("./icc-form-x-api"), exports);
__exportStar(require("./icc-hcparty-x-api"), exports);
__exportStar(require("./icc-helement-x-api"), exports);
__exportStar(require("./icc-invoice-x-api"), exports);
__exportStar(require("./icc-message-x-api"), exports);
__exportStar(require("./icc-patient-x-api"), exports);
__exportStar(require("./icc-user-x-api"), exports);
__exportStar(require("./icc-time-table-x-api"), exports);
__exportStar(require("./icc-receipt-x-api"), exports);
var utils_1 = require("./crypto/utils");
Object.defineProperty(exports, "utils", { enumerable: true, get: function () { return utils_1.utils; } });
Object.defineProperty(exports, "UtilsClass", { enumerable: true, get: function () { return utils_1.UtilsClass; } });
__exportStar(require("./utils"), exports);
const apiHeaders = function (username, password) {
    return {
        Authorization: `Basic ${typeof btoa !== 'undefined' ? btoa(`${username}:${password}`) : Buffer.from(`${username}:${password}`).toString('base64')}`,
    };
};
exports.apiHeaders = apiHeaders;
const Api = function (host, username, password, crypto = typeof window !== 'undefined' ? window.crypto : typeof self !== 'undefined' ? self.crypto : {}, fetchImpl = typeof window !== 'undefined'
    ? window.fetch
    : typeof self !== 'undefined'
        ? self.fetch
        : fetch) {
    const headers = exports.apiHeaders(username, password);
    const authApi = new icc_api_1.IccAuthApi(host, headers, fetchImpl);
    const entityReferenceApi = new icc_api_1.IccEntityrefApi(host, headers, fetchImpl);
    const userApi = new icc_user_x_api_1.IccUserXApi(host, headers, fetchImpl);
    const healthcarePartyApi = new icc_hcparty_x_api_1.IccHcpartyXApi(host, headers, fetchImpl);
    const cryptoApi = new icc_crypto_x_api_1.IccCryptoXApi(host, headers, healthcarePartyApi, new icc_api_1.IccPatientApi(host, headers, fetchImpl), crypto);
    const accessLogApi = new icc_accesslog_x_api_1.IccAccesslogXApi(host, headers, cryptoApi, fetchImpl);
    const contactApi = new icc_contact_x_api_1.IccContactXApi(host, headers, cryptoApi, fetchImpl);
    const formApi = new icc_form_x_api_1.IccFormXApi(host, headers, cryptoApi, fetchImpl);
    const groupApi = new icc_api_1.IccGroupApi(host, headers);
    const invoiceApi = new icc_invoice_x_api_1.IccInvoiceXApi(host, headers, cryptoApi, entityReferenceApi, fetchImpl);
    const insuranceApi = new icc_api_1.IccInsuranceApi(host, headers, fetchImpl);
    const documentApi = new icc_document_x_api_1.IccDocumentXApi(host, headers, cryptoApi, authApi, fetchImpl);
    const healthcareElementApi = new icc_helement_x_api_1.IccHelementXApi(host, headers, cryptoApi, fetchImpl);
    const classificationApi = new icc_classification_x_api_1.IccClassificationXApi(host, headers, cryptoApi, fetchImpl);
    const calendarItemApi = new icc_calendar_item_x_api_1.IccCalendarItemXApi(host, headers, cryptoApi, fetchImpl);
    const receiptApi = new icc_receipt_x_api_1.IccReceiptXApi(host, headers, cryptoApi, fetchImpl);
    const timetableApi = new icc_time_table_x_api_1.IccTimeTableXApi(host, headers, cryptoApi, fetchImpl);
    const patientApi = new icc_patient_x_api_1.IccPatientXApi(host, headers, cryptoApi, contactApi, formApi, healthcareElementApi, invoiceApi, documentApi, healthcarePartyApi, classificationApi, calendarItemApi, ['note'], fetchImpl);
    const messageApi = new icc_message_x_api_1.IccMessageXApi(host, headers, cryptoApi, insuranceApi, entityReferenceApi, invoiceApi, documentApi, receiptApi, patientApi, fetchImpl);
    return {
        cryptoApi,
        authApi,
        userApi,
        patientApi,
        healthcarePartyApi,
        accessLogApi,
        contactApi,
        healthcareElementApi,
        documentApi,
        formApi,
        invoiceApi,
        insuranceApi,
        messageApi,
        entityReferenceApi,
        receiptApi,
        calendarItemApi,
        classificationApi,
        timetableApi,
        groupApi,
    };
};
exports.Api = Api;
//# sourceMappingURL=index.js.map